import { v4 as uuidv4 } from 'uuid';
import { listenEvent } from '../../utils/events';
import { isVariation, parseResponse } from '../../utils/flags';
import { EVENTS_LISTEN, TIMEOUT } from '../../constants';

const isFunction = (obj) => !!obj && typeof obj === 'function';

export default class AndroidFwf {
  fwf = null;
  promises = {};
  timeout = TIMEOUT;

  constructor({ timeout } = {}, context) {
    if (timeout) this.timeout = timeout;

    listenEvent(EVENTS_LISTEN.FLAG_IS_ENABLED, this.onFlagIsEnabled.bind(this));

    this.fwf = window.FwfWebInterface;
    this.setContext(context);
  }

  getFlag(flag, fallback = false) {
    const track = true;
    const forceRequest = false;

    const promise = new Promise((resolve, reject) => {
      const promiseId = uuidv4();

      const timeout = setTimeout(() => {
        this.onFlagIsEnabled({
          detail: {
            promiseId,
            isEnabled: fallback,
            isAbTest: false,
            keyName: flag,
            variation: fallback,
          },
        });
      }, this.timeout);

      this.promises[promiseId] = { resolve, reject, timeout };

      if (this.fwf && isFunction(this.fwf.isEnabled)) {
        this.fwf.isEnabled(promiseId, flag, track, fallback, forceRequest);
      }
    });

    return promise;
  }

  setContext(newContext = {}) {
    if (this.fwf && isFunction(this.fwf.setGlobal)) {
      this.fwf.setGlobal(JSON.stringify(newContext));
    }
  }

  onFlagIsEnabled({ detail }) {
    if (this.promises[detail.promiseId]) {
      const promise = this.promises[detail.promiseId];

      clearTimeout(promise.timeout);

      if (detail.error) {
        promise.reject(detail);
      } else {
        promise.resolve({
          isEnabled: isVariation(detail.isEnabled),
          isAbTest: detail.isAbTest,
          keyName: detail.keyName,
          variation: parseResponse(detail.variation || detail.variationObject),
        });
      }
      delete this.promises[detail.promiseId];
    }
  }
}
